import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';

var LoadingWheelBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "LoadingWheel__LoadingWheelBox",
  componentId: "sc-1z0ucju-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  border-top-style: solid;\n  border-right-style: solid;\n  border-left-style: solid;\n  border-bottom-style: solid;\n  border-top-color: rgba(255, 255, 255, 0.2);\n  border-right-color: rgba(255, 255, 255, 0.2);\n  border-left-color: rgba(255, 255, 255, 0.2);\n  border-bottom-color: ", ";\n  transform: translateZ(0);\n  animation: load8 1.1s infinite linear;\n  overflow: hidden;\n\n  &,\n  &::after {\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n  }\n\n  @keyframes load8 {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  border-top-style: solid;\n  border-right-style: solid;\n  border-left-style: solid;\n  border-bottom-style: solid;\n  border-top-color: rgba(255, 255, 255, 0.2);\n  border-right-color: rgba(255, 255, 255, 0.2);\n  border-left-color: rgba(255, 255, 255, 0.2);\n  border-bottom-color: ", ";\n  transform: translateZ(0);\n  animation: load8 1.1s infinite linear;\n  overflow: hidden;\n\n  &,\n  &::after {\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n  }\n\n  @keyframes load8 {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.mofoGreen;
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var size = _a.size;
  return size;
});
var LoadingWheel = function (_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? "md" : _b,
    _c = _a.borderWidth,
    borderWidth = _c === void 0 ? "1.1em" : _c,
    rest = __rest(_a, ["variant", "borderWidth"]);
  var size = {
    sm: "5em",
    md: "10em",
    lg: "15em"
  }[variant];
  return React__default.createElement(LoadingWheelBox, __assign({
    size: size,
    borderWidth: borderWidth
  }, rest));
};
var templateObject_1;

export { LoadingWheel };
//# sourceMappingURL=LoadingWheel.js.map
